import * as t from 'ts-codec';
import { ResourceId } from '@journeyapps-labs/micro-codecs';
import { ResourceImages } from './types-resources.js';
export const Crop = t.object({
    top: t.number,
    left: t.number,
    width: t.number,
    height: t.number
});
export var Gender;
(function (Gender) {
    Gender["MALE"] = "male";
    Gender["FEMALE"] = "female";
    Gender["TRANS_FEMALE"] = "trans-female";
    Gender["TRANS_MALE"] = "trans-male";
    Gender["NON_BINARY"] = "non-binary";
    Gender["OTHER"] = "other";
})(Gender || (Gender = {}));
/**
 * @todo add feline, pony etc..
 */
export var IdentityType;
(function (IdentityType) {
    IdentityType["PUP"] = "pup";
    IdentityType["HANDLER"] = "handler";
})(IdentityType || (IdentityType = {}));
export var SexualOrientation;
(function (SexualOrientation) {
    SexualOrientation["STRAIGHT"] = "straight";
    SexualOrientation["GAY"] = "gay";
    SexualOrientation["BI"] = "bi";
    SexualOrientation["LESBIAN"] = "lesbian";
    SexualOrientation["OTHER"] = "other";
})(SexualOrientation || (SexualOrientation = {}));
export var RelationshipStatus;
(function (RelationshipStatus) {
    RelationshipStatus["BLANK"] = "blank";
    RelationshipStatus["SINGLE"] = "single";
    RelationshipStatus["DATING"] = "dating";
    RelationshipStatus["IN_RELATIONSHIP"] = "in-relationship";
    RelationshipStatus["OPEN_RELATIONSHIP"] = "open-relationship";
    RelationshipStatus["OTHER"] = "other";
})(RelationshipStatus || (RelationshipStatus = {}));
export const Profile = t.object({
    profile_name: t.string,
    about: t.string.optional(),
    gender: t.Enum(Gender).optional(),
    identity: t.array(t.Enum(IdentityType)).optional(),
    sexual_orientation: t.Enum(SexualOrientation).optional(),
    explicit: t.boolean.optional(),
    relationship_status: t.Enum(RelationshipStatus)
});
export const ProfileResource = Profile.and(ResourceImages)
    .and(ResourceId)
    .and(t.object({
    age: t.number
}));
